import React from 'react';
import { Button } from 'antd';
import { TabContent, EmptyState, AddMappingButton, XPathMappingTable, XPathTableHeader, XPathTableBody } from './styles';
import XPathMappingRow from './XPathMappingRow';
import { BUSINESS_CONTRACTS as trans } from './translationValues';

const XPathMappingsEditor = ({ mappings, onMappingsChange, hasSchema, t, globalVariables = [], updateGlobalVariables, relationships = [] }) => {
  // Ensure mappings is an object
  const mappingsObj = mappings && typeof mappings === 'object' && !Array.isArray(mappings) 
    ? mappings 
    : {};

  const handleAddMapping = () => {
    const newKey = `xpath_${Date.now()}`;
    onMappingsChange({ ...mappingsObj, [newKey]: '' });
  };

  const handleXPathKeyChange = (oldKey, newKey) => {
    if (oldKey === newKey) return;
    const updatedMappings = { ...mappingsObj };
    const value = updatedMappings[oldKey];
    delete updatedMappings[oldKey];
    updatedMappings[newKey] = value;
    onMappingsChange(updatedMappings);
  };

  const handleVariableChange = (key, value) => {
    onMappingsChange({ ...mappingsObj, [key]: value });
  };

  const handleDelete = (key) => {
    const updatedMappings = { ...mappingsObj };
    delete updatedMappings[key];
    onMappingsChange(updatedMappings);
  };

  if (!hasSchema) {
    return (
      <TabContent>
        <EmptyState>
          <h3>{t(trans.IMPORT_YOUR_DATA_FIRST.key, trans.IMPORT_YOUR_DATA_FIRST.value)}</h3>
          <p>{t(trans.IMPORT_DATA_MESSAGE.key, trans.IMPORT_DATA_MESSAGE.value)}</p>
        </EmptyState>
      </TabContent>
    );
  }

  const mappingEntries = Object.entries(mappingsObj);

  return (
    <TabContent style={{ paddingBottom: '20px' }}>
      <AddMappingButton onClick={handleAddMapping} icon="plus">
        {t(trans.ADD_MAPPING.key, trans.ADD_MAPPING.value)}
      </AddMappingButton>
      {mappingEntries.length > 0 ? (
        <XPathMappingTable>
          <XPathTableHeader>
            <div>{t(trans.MAPS_TO_VARIABLE.key, trans.MAPS_TO_VARIABLE.value)}</div>
            <div>{t(trans.XPATH_EXPRESSION.key, trans.XPATH_EXPRESSION.value)}</div>
            <div></div> {/* For delete icon */}
          </XPathTableHeader>
          <XPathTableBody>
            {mappingEntries.map(([xpathKey, variableValue]) => (
              <XPathMappingRow
                key={xpathKey}
                xpathKey={xpathKey}
                variableValue={variableValue}
                onXPathKeyChange={handleXPathKeyChange}
                onVariableChange={handleVariableChange}
                onDelete={handleDelete}
                t={t}
                globalVariables={globalVariables}
                updateGlobalVariables={updateGlobalVariables}
                relationships={relationships}
              />
            ))}
          </XPathTableBody>
        </XPathMappingTable>
      ) : (
        <EmptyState>
          <p>No custom logic mappings yet. Click "Add Mapping" to create one.</p>
        </EmptyState>
      )}
    </TabContent>
  );
};

export default XPathMappingsEditor;

